import React, { Component } from "react";

// import Swiper core and required modules
import SwiperCore, { Navigation, Autoplay } from "swiper";
import { Swiper } from "../../../node_modules/swiper/react/swiper";
import { SwiperSlide } from "../../../node_modules/swiper/react/swiper-slide";

import "../../../node_modules/swiper/swiper-bundle.css";

//Assets
import Demo from "../../Assets/demo.jpg";
import insta from "../../Assets/insta.svg";
import fbook from "../../Assets/facebook.svg";
import twiteer from "../../Assets/twitter.svg";

// install Swiper modules
SwiperCore.use([Navigation, Autoplay]);

export default class ConsultingDoctors extends Component {
  render() {
    return (
      <div className="Home_ConsultingDoctors">
        <div className="Home_ConsultingDoctorsTitle">Consulting Doctors</div>
        <div className="Home_ConsultingDoctorsTitleInfo">
          “For better understanding your health status, we have our doctors
          team. They will help your more to maintain your’s blood glucose.”
        </div>
        <div className="Home_ConsultingDoctorsCardsBlock">
          <Swiper
            slidesPerView={3}
            spaceBetween={0}
            navigation={true}
            grabCursor={true}
            loop={true}
            className="mySwiper"
          >
            {[...Array(10)].map(() => {
              return (
                <SwiperSlide>
                  <div className="Home_ConsultingDoctorsCard">
                    <div className="Home_ConsultingDoctorsCardInfo">
                      <div className="Home_ConsultingDoctorsCardInfoCol1">
                        <img src={Demo} alt="" />
                        <div>Dr Lokesh More</div>
                        <div>Diabetologist, London</div>
                      </div>
                      <div className="Home_ConsultingDoctorsCardInfoCol2">
                        <div className="Home_ConsultingDoctorsCardInfoCol2Item">
                          <div>Degree</div>
                          <div>MBBS, FCPS </div>
                        </div>
                        <div className="Home_ConsultingDoctorsCardInfoCol2Item">
                          <div>Speciality</div>
                          <div>Diabetoligist, London</div>
                        </div>
                        <div className="Home_ConsultingDoctorsCardInfoCol2Item">
                          <div>Contact</div>
                          <div>+91 7058222789</div>
                        </div>

                        <div className="Home_ConsultingDoctorsCardInfoCol2ItemImg">
                          <img src={insta} alt="" />
                          <img src={fbook} alt="" />
                          <img src={twiteer} alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </div>
    );
  }
}
